/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QualificationModel } from '../../models/qualification-model';

export interface QualificationIdGet$Params {
  id: string;
}

export function qualificationIdGet(http: HttpClient, rootUrl: string, params: QualificationIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<QualificationModel>> {
  const rb = new RequestBuilder(rootUrl, qualificationIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<QualificationModel>;
    })
  );
}

qualificationIdGet.PATH = '/Qualification/{id}';
